import axios from "axios";

const ARK_API_URL = process.env.ARK_API_URL;

export const getBannerById = async (postId) => {
    try {
        const { data } = await axios.get(`${ARK_API_URL}/banners/all/${postId}`);
        const post = data.data;
        return post;
    } catch (error) {
        console.error("Error fetching post:", error);
    }
}